<template>
    <app-layout>
        <template #header>
            <h2 class="text-xl font-semibold leading-tight text-iron-800">
                API Tokens
            </h2>
        </template>

        <div>
            <div class="max-w-7xl py-10 sm:px-6 lg:px-8 mx-auto">
                <api-token-manager
                    :tokens="tokens"
                    :available-permissions="availablePermissions"
                    :default-permissions="defaultPermissions"
                />
            </div>
        </div>
    </app-layout>
</template>

<script>
import ApiTokenManager from "./ApiTokenManager.vue";
import AppLayout from "../../Layouts/AppLayout.vue";

export default {
    components: {
        ApiTokenManager,
        AppLayout,
    },
    props: ["tokens", "availablePermissions", "defaultPermissions"],
};
</script>
